import React, { useEffect, useState } from "react";
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Grid,
  Typography,
  Hidden,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Icon } from "@iconify/react";
import _ from "lodash";

import DirectoryContentView from "./components/DirectoryContentView";

// Import modals
import { useForm } from "react-hook-form";
import {
  fetchCategoriesInfo,
  fetchMenusInfo,
} from "../../../../../services/menuApp/menuService";
import {
  fetchGlobalDepartmentInfo,
  fetchGlobalGroupInfo,
  fetchProductConfigInfo,
  fetchProductWrapperInfo,
} from "../../../../../services/menuApp/printerMenuService";
import {
  ERROR_MESSAGE_UNEXPECTED_ERROR,
  SUCCESSFULLY_CREATED,
  SUCCESSFULLY_UPDATED,
} from "../../../../../utils/consts";
import { fetchTags } from "../../../../../services/menuApp/categoryMenuService";
import DefaultAlert from "../../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../../auth/authorities";
import withAuthority from "../../../../../components/Auth/withAuthority";
import PageHeaderMobile from "../../../../../components/common/PageHeader/PageHeaderMobile";
import TextSkeletonLoading from "../../../../../components/common/Loading/TextSkeletonLoading";
import DirectoryOrProductSelectionModal from "../../MenusNewTest/Modal/DirectoryOrProductSelectionModal";
import DirectoryAddModal from "./components/DirectoryAddModal";
import ProductAddModal from "./components/ProductAddModal";
import DirectoryEditModal from "./components/DirectoryEditModal";
import ProductEditModal from "./components/ProductEditModal";
import {
  fetchAllMenuDetails,
  fetchMenuDetails,
  fetchMenus,
  loadCommonData,
  setProductsVersion,
} from "../../../../../redux/actions/menu";
import DirectorySkeletonLoading from "./components/DirectorySkeletonLoading";
import StockDepartmentAddModal from "../../MenusNewTest/Modal/StockDepartmentAddModal";
import {
  createStockDepartments,
  fetchGetAllStockDepartments,
} from "../../../../../services/inventory/stockItems";
import { AxiosError } from "axios";
import EmptyModal from "../../MenusNewTest/Modal/EmptyModal";

interface Params {
  menuId: string;
  locationId: string;
  "0"?: string;
}

const MenuDirectory: React.FunctionComponent = () => {
  const params = useParams<Params>();
  const match: any = useRouteMatch();
  const history = useHistory();
  const dispatch = useDispatch();

  // Extract directory IDs from URL path
  const pathParts = match.url.split("/");
  const directoryIndex = pathParts.indexOf("directory");
  const directoryIds: number[] = [];

  if (directoryIndex !== -1) {
    for (let i = directoryIndex + 1; i < pathParts.length; i++) {
      const id = parseInt(pathParts[i]);
      if (!isNaN(id)) {
        directoryIds.push(id);
      }
    }
  }

  const { menuId, locationId } = params;
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Redux state
  const {
    menuDetails,
    isLoading,
    tags,
    departments,
    groups,
    productConfig,
    menus,
  } = useSelector((state: any) => state.menu);
  const currentMenuData = menuDetails[menuId];

  const [menuNodeList, setMenuNodeList] = useState<any>({});
  const [selectedMenuName, setSelectedMenuName] = useState("");
  const [isLocalLoading, setIsLocalLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [currentDirectory, setCurrentDirectory] = useState<any>(null);
  const [currentCategory, setCurrentCategory] = useState<any>(null);
  const [directoryStack, setDirectoryStack] = useState<any[]>([]);
  const [productVersion, setProductVersion] = useState<any>();
  const [tagsState, setTagsState] = useState<any>({});
  const [stockDepartmentSelectedNode, setStockDepartmentSelectedNode] =
    useState<any>([]);
  const [stockGroupSelectedNode, setStockGroupSelectedNode] = useState<any>([]);
  const [selectedGroupObj, setSelectedGroupObj] = useState<any>({});
  const [categoryNode, setCategoryNode] = useState<any>([]);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);
  const [selectedDepartmentObj, setSelectedDepartmentObj] = useState<any>({});
  // Get basic menu info from menus array
  const basicMenuInfo = menus?.find((m: any) => m.id === parseInt(menuId));

  // Directory Edit Modal States
  const [isOpenDirectoryEditModal, setIsOpenDirectoryEditModal] =
    useState(false);
  const [selectedDirectory, setSelectedDirectory] = useState<any>({});
  const [selectedDirectoryCategory, setSelectedDirectoryCategory] =
    useState<any>({});
  const [directoryIsRoot, setDirectoryIsRoot] = useState(false);
  const [directoryCategoryId, setDirectoryCategoryId] = useState("");
  const [directoryWrapperId, setDirectoryWrapperId] = useState("");
  const [directoryFirstWrapperId, setDirectoryFirstWrapperId] = useState("");
  const [openDepartmentDropdown, setOpenDepartmentDropdown] = useState(false);
  // Directory form states
  const [directoryName, setDirectoryName] = useState("");
  const [directoryUrl, setDirectoryUrl] = useState("");
  const [directoryColor, setDirectoryColor] = useState("");
  const [isDirectoryNameEmpty, setIsDirectoryNameEmpty] = useState(false);
  const [isLoadingDirectoryButton, setIsLoadingDirectoryButton] =
    useState(false);
const [isStack, setIsStack] = useState(false);
  // Product Edit Modal States
  const [isOpenProductEditModal, setIsOpenProductEditModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>({});
  const [selectedProductCategory, setSelectedProductCategory] = useState<any>(
    {},
  );
  const [productIsRoot, setProductIsRoot] = useState(false);
  const [productCategoryId, setProductCategoryId] = useState("");
  const [productWrapperId, setProductWrapperId] = useState("");
  const [productFirstWrapperId, setProductFirstWrapperId] = useState("");

  // Add New Item Modal States
  const [
    isOpenDirectoryOrProductSelectionModal,
    setIsOpenDirectoryOrProductSelectionModal,
  ] = useState(false);
  const [isOpenDirectoryAddModal, setIsOpenDirectoryAddModal] = useState(false);
  const [isOpenProductAddModal, setIsOpenProductAddModal] = useState(false);
  const [newItemCategoryId, setNewItemCategoryId] = useState("");
  const [newItemDirectoryId, setNewItemDirectoryId] = useState("");
  const [newItemDirectoryLevel, setNewItemDirectoryLevel] = useState(1);
  const [newItemIsRoot, setNewItemIsRoot] = useState(false);
  const [newItemFirstWrapperId, setNewItemFirstWrapperId] = useState("");
  const [isOpenGroupAddModal, setIsOpenGroupAddModal] = useState(false);
  // Add New Directory form states
  const [newDirectoryName, setNewDirectoryName] = useState("");
  const [newDirectoryUrl, setNewDirectoryUrl] = useState("");
  const [newDirectoryColor, setNewDirectoryColor] = useState("");
  const [isNewDirectoryNameEmpty, setIsNewDirectoryNameEmpty] = useState(false);
  const [isLoadingNewDirectoryButton, setIsLoadingNewDirectoryButton] =
    useState(false);
  const [groupId, setGroupId] = useState("");
  // Add New Product form states
  const [newProductName, setNewProductName] = useState("");
  const [isNewProductNameEmpty, setIsNewProductNameEmpty] = useState(false);
  const [newProductDepartment, setNewProductDepartment] = useState<any>({});
  const [isNewProductDepartmentEmpty, setIsNewProductDepartmentEmpty] =
    useState(false);
  const [isOpenStackProductModal, setIsOpenStackProductModal] = useState(false);
  // Directory form states
  const [isLoadingMappingModal, setIsLoadingMappingModal] = useState(true);
  const [categoryName, setCategoryName] = useState("");
  // Add New Item Modal States
  const [selectedCategoryForAdd, setSelectedCategoryForAdd] =
    useState<any>(null);
  const [selectedWrapperForAdd, setSelectedWrapperForAdd] = useState<any>(null);
  const [newProductPlu, setNewProductPlu] = useState("");
  const [newProductBarcode, setNewProductBarcode] = useState("");
  const [newProductUpcBarcode, setNewProductUpcBarcode] = useState("");
  const [newProductNameShort, setNewProductNameShort] = useState("");
  const [groupName, setGroupName] = useState("");
  const [isLoadingGroupDepartmentButton, setIsLoadingGroupDepartmentButton] =
    useState(false);
  const [isOpenDepartmentAddModal, setIsOpenDepartmentAddModal] =
    useState(false);
  const [departmentName, setDepartmentName] = useState("");
  const [selectedCatMenuTitle, setSelectedCatMenuTitle] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [printerMappingItemName, setPrinterMappingItemName] = useState(true);
  const [
    selectedPrinterMappingItemOrCategoryId,
    setSelectedPrinterMappingItemOrCategoryId,
  ] = useState("");
  const [isOpenMappingModal, setIsOpenMappingModal] = useState(false);
  const [stackNode, setStackNode] = useState<any>([]);
  const [type, setType] = useState("");
  // Form hooks
  const { register, handleSubmit, errors, reset, setValue } = useForm<any>();

  const productsVersion = useSelector(
    (state: any) => state.menu?.productsVersion || 1,
  );
  const isEditDisabled = productsVersion === 1;

  useEffect(() => {
    if (currentMenuData?.menuNodeList) {
      setMenuNodeList(currentMenuData.menuNodeList || {});
      setSelectedMenuName(
        currentMenuData.selectedMenuName || basicMenuInfo?.name || "",
      );
      setCategoryNode(currentMenuData.categoryNode || []);
      setProductVersion(currentMenuData.productVersion || productConfig);
      setTagsState(currentMenuData.tags || tags);
      setStockDepartmentSelectedNode(
        currentMenuData.stockDepartmentSelectedNode || departments,
      );
      setStockGroupSelectedNode(
        currentMenuData.stockGroupSelectedNode || groups,
      );
      setSelectedGroupObj(currentMenuData.selectedGroupObj || {});
    } else {
      const loadAllData = async () => {
        if (isInitialLoad && (!menus || menus.length === 0)) {
          console.log("Initial load - fetching all menus and details");
          await dispatch(fetchMenus(match.params.locationId));
          await dispatch(fetchAllMenuDetails(match.params.locationId));
          setIsInitialLoad(false);
        }
      };
      loadAllData();
    }
  }, [currentMenuData]);

  // Function to build nested wrapper structure
  const buildNestedWrapperStructure = (
    wrappers: any[],
    targetDirectoryId: number,
  ): any => {
    const nestedWrapper: any = {};

    const childWrappers = wrappers.filter(
      (w) => w.directoryId === targetDirectoryId,
    );

    childWrappers.forEach((wrapper) => {
      if (wrapper.directory) {
        nestedWrapper[wrapper.id] = {
          ...wrapper,
          wrapper: buildNestedWrapperStructure(wrappers, wrapper.id),
        };
      } else {
        nestedWrapper[wrapper.id] = wrapper;
      }
    });

    return nestedWrapper;
  };

  // Function to find a directory in the nested structure by ID and build the full stack
  const findDirectoryAndBuildStack = (
    wrapperObj: any,
    targetId: number,
    currentStack: any[] = [],
  ): { directory: any; stack: any[] } | null => {
    if (!wrapperObj) return null;

    for (const key in wrapperObj) {
      const item = wrapperObj[key];
      if (!item) continue;

      if (item.id === targetId && item.directory) {
        return { directory: item, stack: [...currentStack, item] };
      }

      if (item.wrapper && typeof item.wrapper === "object") {
        const found = findDirectoryAndBuildStack(item.wrapper, targetId, [
          ...currentStack,
          item,
        ]);
        if (found) return found;
      }
    }
    return null;
  };

  // Function to find and build a directory with its nested structure
  const findAndBuildDirectory = (
    wrappers: any[],
    targetDirectoryId: number,
    category: any,
  ): any => {
    const directory = wrappers.find((w) => w.id === targetDirectoryId);
    if (directory) {
      return {
        ...directory,
        wrapper: buildNestedWrapperStructure(wrappers, targetDirectoryId),
      };
    }
    return null;
  };

  // Function to update directory in nested structure (Recursive)
  const updateDirectoryInNestedStructure = (
    wrapperObj: any,
    targetId: number,
    updatedData: any,
  ): boolean => {
    if (!wrapperObj) return false;

    for (const key in wrapperObj) {
      const item = wrapperObj[key];
      if (!item) continue;

      if (item.id === targetId) {
        const existingWrapper = item.wrapper || {};
        wrapperObj[key] = {
          ...item,
          ...updatedData,
          wrapper: existingWrapper,
        };
        return true;
      }
      if (item.wrapper && typeof item.wrapper === "object") {
        if (
          updateDirectoryInNestedStructure(item.wrapper, targetId, updatedData)
        ) {
          return true;
        }
      }
    }
    return false;
  };

  // Add getAllStockDepartments function for ProductEditModal compatibility
  const getAllStockDepartments = async (id?: any): Promise<void> => {
    try {
      // Attempt to fetch stock department information using the 'fetchGetAllStockDepartments' API function
      const res = await fetchGetAllStockDepartments(match.params.locationId);
      // Iterate through the department data to find the one with the matching 'id' (if provided)

      // Check if the response contains data and update the component's state accordingly
      if (res?.data?.data) {
        res.data.data.map((data: any) => {
          if (data.id === id) {
            setSelectedDepartmentObj(data);
          }
        });
        setStockDepartmentSelectedNode(res.data.data);
      } else {
        // If no data is available, set an empty array for 'stockDepartmentSelectedNode'
        setStockDepartmentSelectedNode([]);
      }
    } catch (err) {
      // If an error occurs during the API call, set the 'error' state with an unexpected error message
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  const getMenuDetails = async () => {
    try {
      setIsLocalLoading(true);
      // Fetch data using Redux
      await dispatch(fetchMenuDetails(locationId, menuId));
      await dispatch(loadCommonData(locationId));
      setIsLocalLoading(false);
    } catch (error) {
      console.error("Error fetching menu details:", error);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLocalLoading(false);
    }
  };

  const getProductConfiguration = async () => {
    if (!locationId) return;

    try {
      const { data } = await fetchProductConfigInfo(locationId);
      if (data && data.data) {
        const version = data.data.productsVersion || 1;
        setProductsVersion(version);
        // Dispatch to Redux
        dispatch(setProductsVersion(version));
      }
    } catch (error) {
      const err: any = error as AxiosError;
      if (err.response?.status !== 404) {
        console.error("Error fetching product configuration:", error);
      }
    } finally {
    }
  };

  // Initial load - fetch all menu details at once
  useEffect(() => {
    const loadAllData = async () => {
      if (isInitialLoad && (!menus || menus.length === 0)) {
        console.log("Initial load - fetching all menus and details");
        await dispatch(fetchMenus(match.params.locationId));
        await dispatch(fetchAllMenuDetails(match.params.locationId));
        await getProductConfiguration();
        setIsInitialLoad(false);
      }
    };
    loadAllData();
  }, []);

  // Find directory from menuNodeList based on directoryIds
  useEffect(() => {
    if (
      menuNodeList &&
      Object.keys(menuNodeList).length > 0 &&
      directoryIds.length > 0
    ) {
      let foundDirectory: any = null;
      let foundStack: any[] = [];
      let foundCategory: any = null;

      let currentSearchLevel: any = menuNodeList[menuId];

      for (let i = 0; i < directoryIds.length; i++) {
        const targetId = directoryIds[i];
        let found = false;

        if (i === 0 && currentSearchLevel?.category) {
          for (const catKey in currentSearchLevel.category) {
            const category = currentSearchLevel.category[catKey];
            if (category.wrapper) {
              const result = findDirectoryAndBuildStack(
                category.wrapper,
                targetId,
                [],
              );
              if (result) {
                foundDirectory = result.directory;
                foundStack = result.stack;
                currentSearchLevel = result.directory;
                foundCategory = category;
                found = true;
                break;
              }
            }
          }
        } else if (currentSearchLevel?.wrapper) {
          const result = findDirectoryAndBuildStack(
            currentSearchLevel.wrapper,
            targetId,
            [],
          );
          if (result) {
            foundDirectory = result.directory;
            foundStack = [...foundStack, ...result.stack];
            currentSearchLevel = result.directory;
            found = true;
          }
        }

        if (!found) break;
      }

      setCurrentDirectory(foundDirectory);
      setDirectoryStack(foundStack);
      setCurrentCategory(foundCategory);
    }
  }, [menuNodeList]);

  // Function to update directory using response data
  const handleDirectoryUpdated = async (updatedDirectoryRaw: any) => {
    console.log("asdfsadgsfhfdgs", updatedDirectoryRaw);
    const updatedItem = Array.isArray(updatedDirectoryRaw)
      ? updatedDirectoryRaw[0]
      : updatedDirectoryRaw;

    const updatedMenuList = _.cloneDeep(menuNodeList);

    if (updatedMenuList[menuId]?.category) {
      for (const catKey in updatedMenuList[menuId].category) {
        const category = updatedMenuList[menuId].category[catKey];
        if (category.wrapper) {
          updateDirectoryInNestedStructure(
            category.wrapper,
            updatedItem.id,
            updatedItem,
          );
        }
      }
    }

    const newStack = directoryStack.map((dir) => {
      if (dir.id === updatedItem.id) {
        return { ...dir, ...updatedItem, wrapper: dir.wrapper || {} };
      }
      return dir;
    });

    if (currentDirectory) {
      if (currentDirectory.id === updatedItem.id) {
        setCurrentDirectory({
          ...currentDirectory,
          ...updatedItem,
          wrapper: currentDirectory.wrapper || {},
        });
      } else if (
        currentDirectory.wrapper &&
        currentDirectory.wrapper[updatedItem.id]
      ) {
        const newCurrentDir = { ...currentDirectory };
        newCurrentDir.wrapper[updatedItem.id] = {
          ...newCurrentDir.wrapper[updatedItem.id],
          ...updatedItem,
        };
        setCurrentDirectory(newCurrentDir);
      }
    }

    setMenuNodeList(updatedMenuList);
    setDirectoryStack(newStack);
    setForceUpdateKey((prev) => prev + 1);
    setSuccess(SUCCESSFULLY_UPDATED);
    setTimeout(() => setSuccess(""), 3000);

    // Refresh data from Redux to update cache
    dispatch(fetchMenuDetails(locationId, menuId));
  };

  // Function to update UI after adding new item
  const handleItemAdded = (newItem: any) => {
    // Normalize the new item
    let normalizedItem = { ...newItem };
    if (
      normalizedItem.categoryId &&
      typeof normalizedItem.categoryId === "object"
    ) {
      normalizedItem.categoryId = normalizedItem.categoryId.id;
    }
    if (
      normalizedItem.itemWrapperId?.categoryId &&
      typeof normalizedItem.itemWrapperId.categoryId === "object"
    ) {
      normalizedItem.itemWrapperId.categoryId =
        normalizedItem.itemWrapperId.categoryId.id;
    }

    // Update the current directory's wrapper with the new item
    if (currentDirectory && normalizedItem) {
      const updatedWrapper = {
        ...currentDirectory.wrapper,
        [normalizedItem.id]: normalizedItem,
      };

      const updatedCurrentDirectory = {
        ...currentDirectory,
        wrapper: updatedWrapper,
      };
      setCurrentDirectory(updatedCurrentDirectory);

      const updatedStack = directoryStack.map((dir) => {
        if (dir.id === currentDirectory.id) {
          return updatedCurrentDirectory;
        }
        return dir;
      });
      setDirectoryStack(updatedStack);

      const updatedMenuList = _.cloneDeep(menuNodeList);
      if (updatedMenuList[menuId]?.category) {
        for (const catKey in updatedMenuList[menuId].category) {
          const category = updatedMenuList[menuId].category[catKey];
          if (category.wrapper) {
            const findAndAddToWrapper = (wrapperObj: any): boolean => {
              for (const key in wrapperObj) {
                if (
                  wrapperObj[key] &&
                  wrapperObj[key].id === normalizedItem.directoryId
                ) {
                  if (!wrapperObj[key].wrapper) {
                    wrapperObj[key].wrapper = {};
                  }
                  wrapperObj[key].wrapper[normalizedItem.id] = normalizedItem;
                  return true;
                }
                if (wrapperObj[key] && wrapperObj[key].wrapper) {
                  if (findAndAddToWrapper(wrapperObj[key].wrapper)) {
                    return true;
                  }
                }
              }
              return false;
            };
            findAndAddToWrapper(category.wrapper);
          }
        }
      }
      setMenuNodeList(updatedMenuList);
    }

    setForceUpdateKey((prev) => prev + 1);
    setSuccess(SUCCESSFULLY_CREATED);
    setTimeout(() => setSuccess(""), 3000);

    // Refresh data from Redux to update cache
    dispatch(fetchMenuDetails(locationId, menuId));
  };

  // Add New Item Handlers
  const handleOpenAddItemModal = () => {
    setIsOpenDirectoryOrProductSelectionModal(true);
  };

  const handleOpenDirectoryModal = () => {
    setIsOpenDirectoryOrProductSelectionModal(false);

    if (currentCategory) {
      setNewItemCategoryId(currentCategory.id);
    }

    if (currentDirectory) {
      setNewItemDirectoryId(currentDirectory.id);
      setNewItemDirectoryLevel((currentDirectory.directoryLevel || 1) + 1);
      setNewItemFirstWrapperId(currentDirectory.id);
      setNewItemIsRoot(false);
    } else {
      setNewItemDirectoryId("");
      setNewItemDirectoryLevel(1);
      setNewItemFirstWrapperId("");
      setNewItemIsRoot(true);
    }

    setNewDirectoryName("");
    setNewDirectoryUrl("");
    setNewDirectoryColor("");
    setIsNewDirectoryNameEmpty(false);
    setIsOpenDirectoryAddModal(true);
  };

  const handleOpenProductModal = () => {
    setIsOpenDirectoryOrProductSelectionModal(false);

    if (currentCategory) {
      setNewItemCategoryId(currentCategory.id);
    }

    if (currentDirectory) {
      setNewItemDirectoryId(currentDirectory.id);
      setNewItemDirectoryLevel((currentDirectory.directoryLevel || 1) + 1);
      setNewItemFirstWrapperId(currentDirectory.id);
      setNewItemIsRoot(false);
    } else {
      setNewItemDirectoryId("");
      setNewItemDirectoryLevel(1);
      setNewItemFirstWrapperId("");
      setNewItemIsRoot(true);
    }

    setNewProductName("");
    setNewProductPlu("");
    setNewProductBarcode("");
    setNewProductUpcBarcode("");
    setNewProductNameShort("");
    setNewProductDepartment({});
    setIsNewProductNameEmpty(false);
    setIsNewProductDepartmentEmpty(false);
    setIsOpenProductAddModal(true);
  };

  const handleCloseSelectionModal = () => {
    setIsOpenDirectoryOrProductSelectionModal(false);
  };

  const handleCloseDirectoryAddModal = () => {
    setIsOpenDirectoryAddModal(false);
    setNewDirectoryName("");
    setNewDirectoryUrl("");
    setNewDirectoryColor("");
  };

  const handleCloseProductAddModal = () => {
    setIsOpenProductAddModal(false);
    setNewProductName("");
    setNewProductDepartment({});
  };

  const handleBackToMenus = () => {
    const basePath = match.url.split(`/${menuId}`)[0];
    history.push(basePath);
  };

  // Directory Edit Modal Handlers
  const handleOpenDirectoryEditModal = (
    product: any,
    wrapper: any,
    category: any,
    isOpenWrapperEditModalVal: any,
    isRootValue: any,
  ) => {
    setSelectedDirectory(product);
    setSelectedDirectoryCategory(category);
    setDirectoryCategoryId(category.id);
    setDirectoryWrapperId(product.id);
    setDirectoryFirstWrapperId(wrapper?.id || product.id);
    setDirectoryIsRoot(isRootValue);

    setDirectoryName(product.name || "");
    setDirectoryUrl(product.img || "");
    setDirectoryColor(product.colour || "");
    setIsDirectoryNameEmpty(false);

    setIsOpenDirectoryEditModal(true);
  };

  const handleCloseDirectoryEditModal = () => {
    setIsOpenDirectoryEditModal(false);
    setSelectedDirectory({});
    setSelectedDirectoryCategory({});
    setDirectoryCategoryId("");
    setDirectoryWrapperId("");
    setDirectoryFirstWrapperId("");
    setDirectoryName("");
    setDirectoryUrl("");
    setDirectoryColor("");
    setIsDirectoryNameEmpty(false);
  };

  // Product Edit Modal Handlers
  const handleOpenProductEditModal = (
    product: any,
    wrapper: any,
    category: any,
    isOpenWrapperEditModalVal: any,
    isRootValue: any,
  ) => {
    setSelectedProduct(product);
    setSelectedProductCategory(category);
    setProductCategoryId(category.id);
    setProductWrapperId(product.id);
    setProductFirstWrapperId(wrapper?.id || product.id);
    setProductIsRoot(isRootValue);
    setIsOpenProductEditModal(true);
  };

  const handleCloseProductEditModal = () => {
    setIsOpenProductEditModal(false);
    setSelectedProduct({});
    setSelectedProductCategory({});
    setProductCategoryId("");
    setProductWrapperId("");
    setProductFirstWrapperId("");
  };

  // Other modal handlers
 const handleOpenMappingModal = (
    event: any,
    category: any,
    item: any,
    categoryOrItem: string,
    isMap?: any,
  ) => {
    if (event) {
      event.stopPropagation();
    }
    setIsOpenModal(true);
    setIsLoadingMappingModal(true);
    setCategoryName(category?.name || "");
    setPrinterMappingItemName(item?.name || "");
    setType(categoryOrItem);
    setIsStack(categoryOrItem === "item" && !!isMap);
    setSelectedPrinterMappingItemOrCategoryId(item?.id);
    setIsLoadingMappingModal(false);
    setIsOpenStackProductModal(false);
    setIsOpenMappingModal(true);
  };

  const handleOpenProductOrDirectoryModals = (category: any, wrapper?: any) => {
    console.log("Open product or directory modal", category, wrapper);
  };

  const setIsProductAdd = (value: any) => {
    console.log("Set is product add", value);
  };

  const handleClickLinkedId = (
    e: any,
    category: any,
    categoryIdValue: any,
  ) => {};
  const handleClearStrip = (product: any) => {};
  const handleNavigate = (product: any, level: any, data: any) => {};

  const isOpenWrapperEditModal = false;
  const isRoot = false;
  const firstWrapperId = "";
  const wrapperId = "";
  const removedLinkedIdLists = {};

  if (
    (isLoading || isLocalLoading) &&
    !currentMenuData?.menuNodeList &&
    isInitialLoad
  ) {
    return <DirectorySkeletonLoading />;
  }

  const handleOpenDepartmentAddModal = () => {
    setDepartmentName("");
    setIsOpenDepartmentAddModal(true);
  };

  const handleCreateNewDepartment = async () => {
    const departmentData = {
      name: departmentName,
      stockGroupId: selectedGroupObj.id,
      locationId: match.params.locationId,
    };

    try {
      let message = "";
      let body = {};

      message = "Inventory Department Information created";
      const summary = `Create New Department: ${departmentName}`;
      body = {
        message,
        summary: JSON.stringify(summary),
        type: "stock_item_info",
        code: "create",
        access_type: false,
        metadata: { changedBy: "" },
      };

      // Attempt to create a new department via an API call
      const response: any = await createStockDepartments(
        match.params.locationId,
        departmentData,
        body,
        "inventory",
      );
      // Set the group ID based on the API response
      setGroupId(response.data.data.stockGroupId.id);

      // Fetch all stock departments for the newly created department
      getAllStockDepartments(response.data.data.id);

      // Close the department add modal upon successful creation
      setIsOpenDepartmentAddModal(false);
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  const handleGroupChange = (e: any, groupData: any) => {
    setSelectedGroupObj(groupData);
    setGroupId(groupData.id);
  };

  const handleOpenGroupAddModal = () => {
    setGroupName("");
    setIsOpenGroupAddModal(true);
  };

  const handleCreateNewGroup = async () => {};

  const handleChangeDepartmentName = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setDepartmentName(event.target.value);
  };

  const handleChangeGroupName = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setGroupName(event.target.value);
  };
  const baseUrl = match.url.split(`/${menuId}`)[0];

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>

      <DirectoryContentView
        key={forceUpdateKey}
        currentDirectory={currentDirectory}
        currentCategory={currentCategory}
        directoryStack={directoryStack}
        menuNodeList={menuNodeList}
        selectedMenuId={menuId}
        selectedMenuName={selectedMenuName}
        locationId={locationId}
        setMenuNodeList={setMenuNodeList}
        productVersion={productVersion}
        tags={tagsState}
        onNavigateToDirectory={(dir, stack) => {
          setCurrentDirectory(dir);
          setDirectoryStack(stack);
          setForceUpdateKey((prev) => prev + 1);
          let path = `${baseUrl}/${menuId}`;
          for (let i = 0; i < stack.length; i++) {
            path += `/directory/${stack[i].id}`;
          }
          history.push(path);
        }}
        onBack={handleBackToMenus}
        baseUrl={baseUrl}
        onAddItemClick={handleOpenAddItemModal}
        handleOpenDirectoryEditModal={handleOpenDirectoryEditModal}
        handleOpenProductEditModal={handleOpenProductEditModal}
        handleOpenMappingModal={handleOpenMappingModal}
        handleOpenProductOrDirectoryModals={handleOpenProductOrDirectoryModals}
        setIsProductAdd={setIsProductAdd}
        setError={setError}
        isOpenWrapperEditModal={isOpenWrapperEditModal}
        isRoot={isRoot}
        firstWrapperId={firstWrapperId}
        wrapperId={wrapperId}
        removedLinkedIdLists={removedLinkedIdLists}
        handleClickLinkedId={handleClickLinkedId}
        handleClearStrip={handleClearStrip}
        handleNavigate={handleNavigate}
        onDirectoryUpdated={handleDirectoryUpdated}
        isEditDisabled={isEditDisabled}
      />

      {/* Directory Or Product Selection Modal */}
      <DirectoryOrProductSelectionModal
        isOpen={isOpenDirectoryOrProductSelectionModal}
        setIsOpen={setIsOpenDirectoryOrProductSelectionModal}
        handleOpenDirectoryModal={handleOpenDirectoryModal}
        handleOpenProductModal={handleOpenProductModal}
        handleCloseDirectoryOrProductSelectionModal={handleCloseSelectionModal}
      />

      {/* Directory Add Modal */}
      <DirectoryAddModal
        isOpen={isOpenDirectoryAddModal}
        setIsOpen={setIsOpenDirectoryAddModal}
        setDirectoryName={setNewDirectoryName}
        directoryName={newDirectoryName}
        isDirectoryNameEmpty={isNewDirectoryNameEmpty}
        setIsDepartmentEmpty={setIsNewDirectoryNameEmpty}
        handleCloseDirectoryAddModal={handleCloseDirectoryAddModal}
        setUrl={setNewDirectoryUrl}
        isLoadingButton={isLoadingNewDirectoryButton}
        url={newDirectoryUrl}
        setIsLoadingButton={setIsLoadingNewDirectoryButton}
        categoryId={newItemCategoryId}
        directoryId={newItemDirectoryId}
        directoryLevel={newItemDirectoryLevel}
        setSuccess={setSuccess}
        setError={setError}
        setIsDirectoryNameEmpty={setIsNewDirectoryNameEmpty}
        menuNodeList={menuNodeList}
        wrapperId={newItemFirstWrapperId}
        menuId={menuId}
        firstWrapperId={newItemFirstWrapperId}
        setMenuNodeList={setMenuNodeList}
        isRoot={newItemIsRoot}
        setIsOpenDirectoryOrProductSelectionModal={
          setIsOpenDirectoryOrProductSelectionModal
        }
        color={newDirectoryColor}
        setColor={setNewDirectoryColor}
        onItemAdded={handleItemAdded}
      />

      {/* Product Add Modal */}
      <ProductAddModal
        isOpen={isOpenProductAddModal}
        setIsOpen={setIsOpenProductAddModal}
        handleCloseProductAddModal={handleCloseProductAddModal}
        stockDepartmentSelectedNode={stockDepartmentSelectedNode}
        categoryId={newItemCategoryId}
        directoryId={newItemDirectoryId}
        directoryLevel={newItemDirectoryLevel}
        menuNodeList={menuNodeList}
        selectedMenuId={menuId}
        firstWrapperId={newItemFirstWrapperId}
        setMenuNodeList={setMenuNodeList}
        setSuccess={setSuccess}
        setError={setError}
        isRoot={newItemIsRoot}
        menuId={menuId}
        setIsOpenDirectoryOrProductSelectionModal={
          setIsOpenDirectoryOrProductSelectionModal
        }
        onItemAdded={handleItemAdded}
        wrapperId={newItemFirstWrapperId}
        setSelectedDepartmentObj={setSelectedDepartmentObj}
        selectedDepartmentObj={selectedDepartmentObj}
        handleOpenDepartmentAddModal={handleOpenDepartmentAddModal}
      />

      {/* Directory Edit Modal */}
      <DirectoryEditModal
        isOpen={isOpenDirectoryEditModal}
        setIsOpen={setIsOpenDirectoryEditModal}
        setDirectoryName={setDirectoryName}
        directoryName={directoryName}
        isDirectoryNameEmpty={isDirectoryNameEmpty}
        setIsDepartmentEmpty={setIsDirectoryNameEmpty}
        handleCloseDirectoryEditModal={handleCloseDirectoryEditModal}
        setUrl={setDirectoryUrl}
        isLoadingButton={isLoadingDirectoryButton}
        url={directoryUrl}
        setIsLoadingButton={setIsLoadingDirectoryButton}
        categoryId={directoryCategoryId}
        directoryId={directoryWrapperId}
        directoryLevel={1}
        setSuccess={setSuccess}
        setError={setError}
        setIsDirectoryNameEmpty={setIsDirectoryNameEmpty}
        menuNodeList={menuNodeList}
        wrapperId={directoryWrapperId}
        menuId={menuId}
        firstWrapperId={directoryFirstWrapperId}
        setMenuNodeList={setMenuNodeList}
        isRoot={directoryIsRoot}
        setIsOpenDirectoryOrProductSelectionModal={() => {}}
        selectedWrapper={selectedDirectory}
        setColor={setDirectoryColor}
        color={directoryColor}
        onDirectoryUpdated={handleDirectoryUpdated}
        setCurrentContent={() => {}}
        setCurrentDirectoryStack={() => {}}
        currentDirectoryStack={directoryStack}
        isEditDisabled={isEditDisabled}
      />

      {/* Product Edit Modal */}
      <ProductEditModal
        isOpen={isOpenProductEditModal}
        setIsOpen={setIsOpenProductEditModal}
        handleCloseProductEditModal={handleCloseProductEditModal}
        isLoadingButton={false}
        errors={errors}
        register={register}
        handleOpenDepartmentAddModal={handleOpenDepartmentAddModal}
        stockDepartmentSelectedNode={stockDepartmentSelectedNode}
        selectedDepartmentObj={{}}
        setSelectedDepartmentObj={() => {}}
        setDepartmentName={() => {}}
        isDepartmentEmpty={false}
        setIsDepartmentEmpty={() => {}}
        reset={reset}
        isValidProduct={true}
        setIsValidProduct={() => {}}
        inTax={{}}
        setInTax={() => {}}
        isByo={false}
        setIsByo={() => {}}
        isCustomisationPriority={false}
        setIsCustomisationPriority={() => {}}
        setIsMirrored={() => {}}
        isSpicySelectionEnabled={false}
        setIsSpicySelectionEnabled={() => {}}
        outTax={{}}
        setOutTax={() => {}}
        allYouCanEat={false}
        setAllYouCanEat={() => {}}
        setColor={() => {}}
        color=""
        setIsValidKiosk={() => {}}
        isValidKiosk={true}
        isDirty={false}
        selectedWrapper={selectedProduct}
        setError={setError}
        productId={productWrapperId}
        menuNodeList={menuNodeList}
        selectedMenuId={menuId}
        categoryId={productCategoryId}
        wrapperId={productWrapperId}
        setMenuNodeList={setMenuNodeList}
        setIsOpenProductEditModal={setIsOpenProductEditModal}
        setIsLoadingButton={() => {}}
        handleSubmit={handleSubmit}
        menuId={menuId}
        firstWrapperId={productFirstWrapperId}
        isRoot={productIsRoot}
        getAllStockDepartments={getAllStockDepartments}
        refreshPrices={async () => {}}
        departmentList={[]}
        setDepartmentList={() => {}}
        isEditDisabled={isEditDisabled}
      />

      <EmptyModal
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        isOpenMappingModal={isOpenMappingModal}
        setError={setError}
        printerMappingItemName={printerMappingItemName}
        selectedPrinterMappingItemOrCategoryId={
          selectedPrinterMappingItemOrCategoryId
        }
        type={type}
        selectedCatMenuTitle={selectedCatMenuTitle}
        categoryName={categoryName}
        isLoading={isLoadingMappingModal}
        setIsLoading={setIsLoadingMappingModal}
        isOpenStackProductModal={isOpenStackProductModal}
        setIsOpenStackProductModal={setIsOpenStackProductModal}
        stackNode={stackNode}
        handleOpenMappingModal={handleOpenMappingModal}
        setIsOpenMappingModal={setIsOpenMappingModal}
        isStack={isStack}
        isEditDisabled={isEditDisabled}
      />

      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity="success"
      />

      {isOpenDepartmentAddModal && (
        <StockDepartmentAddModal
          isOpenDepartmentAddModal={isOpenDepartmentAddModal}
          setIsOpenDepartmentAddModal={setIsOpenDepartmentAddModal}
          setOpen={setOpenDepartmentDropdown}
          open={openDepartmentDropdown}
          stockGroupSelectedNode={stockGroupSelectedNode}
          selectedGroupObj={selectedGroupObj}
          isLoadingToast={false}
          handleGroupChange={handleGroupChange}
          handleOpenGroupAddModal={handleOpenGroupAddModal}
          departmentName={departmentName}
          handleChangeDepartmentName={handleChangeDepartmentName}
          handleCreateNewDepartment={handleCreateNewDepartment}
          isLoadingButton={isLoadingGroupDepartmentButton}
        />
      )}
    </>
  );
};

export default withAuthority(MenuDirectory, Authorities.MENU_READ);
